/* dtf-motion.js — GSAP ScrollTrigger parallax on homepage media.
   Loaded homepage-only (from dtf-rtp). Guards: reduced-motion off + desktop >=1024px. */
(function(){
  try{
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 1024) return;
    var imgs = [].slice.call(document.querySelectorAll('.dtf-home .showcase img, .dtf-home .process__media img'));
    if (!imgs.length) return;
    imgs.forEach(function(im){ im.parentNode.style.overflow = 'hidden'; im.style.willChange = 'transform'; });
    function load(src, cb){ var el=document.createElement('script'); el.src=src; el.async=true; el.onload=cb; el.onerror=function(){}; document.head.appendChild(el); }
    load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js', function(){
      load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js', function(){
        if (!window.gsap || !window.ScrollTrigger) return;
        gsap.registerPlugin(ScrollTrigger);
        imgs.forEach(function(im){
          gsap.set(im, { scale: 1.14 });
          gsap.fromTo(im, { yPercent: -7 }, { yPercent: 7, ease: 'none',
            scrollTrigger: { trigger: im.parentNode, start: 'top bottom', end: 'bottom top', scrub: 0.6 } });
        });
      });
    });
  }catch(e){}
})();
